import type { Environment } from './environment.types';

const mode = import.meta.env.MODE;

let env: Environment;

if (mode === 'production') {
    env = (await import('./environment.production')).environment;
} else if (mode === 'staging') {
    env = (await import('./environment.staging')).environment;
} else if (mode === 'development') {
    env = (await import('./environment.development')).environment;
} else {
    env = (await import('./environment.local')).environment;
}

export { env };
export type { Environment };
